import React from 'react';
import PropTypes from 'prop-types';
/* helpers */
import { httpRequest } from '../../utils/xml-request-helper';
/* Components */
import Input from '../../components/input/input';
import ScrollArea from '../../components/scroll-area/scroll-area';
import Validation from '../../components/validation/validation';
import FlipSwitch from '../../components/flip-switch/flip-switch';
/* styles */
import './schemes.scss';

class SamlFormPage extends React.PureComponent {
    state = {
        model: { ...this.props.model }
    };

    setValue = (prop) => (value) => {
        this.setState({
            model: {
                ...this.state.model,
                [prop]: value
            }
        });
    };

    handleSubmit = formElement => {
        const form = new FormData(formElement);
        httpRequest({
            method: 'POST',
            url: '/Schemes/EditSamlServerConfiguration',
            token: this.props.token,
            onSuccess: window.setTimeout(() => { window.location.href = '/Schemes'; }, 500),
            body: form
        });
    };

    render() {
        return (
            <div className="sten-content sten-schemes-form-page">
                <div className="sten-content__header flex-row">
                    <div className="flex-shrink">
                        <a rel="prev" className="btn-link icon" href="/schemes" title="Back to schemes list">
                            <span className="icon icon-arrow-left" />
                        </a>
                    </div>
                    <div className="flex-grow">
                        <h1 className="sten-content__title text-uppercase">Edit Saml Tenant Configuration</h1>
                    </div>
                </div>
                <ScrollArea className="sten-content__body">
                    <Validation.Form
                        method="post"
                        name="EditSamlServerConfiguration"
                        onSubmit={this.handleSubmit}
                    >
                        <div className="sten-content__section">
                            <div className="row">
                                <div className="col-lg-8 col-md-12 col-sm-16 col-xs-24">
                                    <div className="form-row">
                                        <div className="row flex-row flex-center">
                                            <div className="col-12">
                                                <label className="label">Entity Id</label>
                                                <Input
                                                    disabled
                                                    name="EntityId"
                                                    type="text"
                                                    value={this.state.model.entityId}
                                                    onChange={this.setValue('entityId')}
                                                    placeholder="Enter Entity Id"
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label className="label">Omit Assertion Signature Check</label>
                                                <FlipSwitch
                                                    name="OmitAssertionSignatureCheck"
                                                    activeLabel="Yes"
                                                    inactiveLabel="No"
                                                    isActive={this.state.model.omitAssertionSignatureCheck}
                                                    onChange={this.setValue('omitAssertionSignatureCheck')}
                                                >
                                                    Omit Assertion Signature Check
                                                </FlipSwitch>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <label className="label">
                                            Assertion Consumer Service Url
                                            <div className="text-muted">
                                                (if not set: <i>Saml2/AssertionConsumerService</i>)
                                            </div>
                                        </label>
                                        <Validation.Wrapper validations={{ required: true }}>
                                            <Input
                                                name="AssertionConsumerServiceUrl"
                                                type="text"
                                                value={this.state.model.assertionConsumerServiceUrl}
                                                onChange={this.setValue('assertionConsumerServiceUrl')}
                                                placeholder="Enter Assertion Consumer Service Url"
                                            />
                                        </Validation.Wrapper>
                                    </div>
                                    <div className="form-row">
                                        <label className="label">
                                            Single Logout Service Url
                                            <div className="text-muted">
                                                (if not set: <i>Saml2/SingleLogoutService</i>)
                                            </div>
                                        </label>
                                        <Validation.Wrapper validations={{ required: true }}>
                                            <Input
                                                name="SingleLogoutServiceUrl"
                                                type="text"
                                                value={this.state.model.singleLogoutServiceUrl}
                                                onChange={this.setValue('singleLogoutServiceUrl')}
                                                placeholder="Enter Single Logout Service Url"
                                            />
                                        </Validation.Wrapper>
                                    </div>
                                    <div className="form-row">
                                        <label className="label">
                                            Single Logout Response Service Url
                                            <div className="text-muted">
                                                (if not set: <i>Saml2/SingleLogoutService</i>)
                                            </div>
                                        </label>
                                        <Validation.Wrapper validations={{ required: true }}>
                                            <Input
                                                name="SingleLogoutResponseServiceUrl"
                                                type="text"
                                                value={this.state.model.singleLogoutResponseServiceUrl}
                                                onChange={this.setValue('singleLogoutResponseServiceUrl')}
                                                placeholder="Enter Single Logout Response Service Url"
                                            />
                                        </Validation.Wrapper>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section className="sten-content__section">
                            <div className="row">
                                <div className="col-lg-8 col-md-12 col-sm-16 col-xs-24">
                                    <Validation.Button className="btn btn--primary col-24">
                                        Save Changes
                                    </Validation.Button>
                                </div>
                            </div>
                        </section>
                        <input type="hidden" name="__RequestVerificationToken" value={this.props.token} />
                    </Validation.Form>
                </ScrollArea>
            </div>
        );
    }
}

SamlFormPage.propTypes = {
    token: PropTypes.string.isRequired,
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default SamlFormPage;
